<ng-container>
  <fin-loyalty-section-navigation [mobile]="true"></fin-loyalty-section-navigation>
  <div>
    <div
      class="grid-col-12 pr-large-b pr-medium-t padding-left-gutter padding-right-gutter grid-max-width center ng-star-inserted"
    >
      <div class="col-1-12 font-heading-2 nordic-blue-900-text bold-type" data-testid="loyalty-view-page-title">
        {{ pageTitle }}
      </div>
    </div>
    <div class="grid-col-12 grid-max-width padding-left-gutter padding-right-gutter center">
      <div class="col-1-12 md-col-1-3 dn-laptop-down">
        <fcom-plus-card *ngIf="showPlusCard" class="ms-xxlarge-b"></fcom-plus-card>

        <fin-loyalty-section-navigation></fin-loyalty-section-navigation>

        <fin-announcement-card *ngIf="showAnnouncementCard" class="ms-xxlarge-t block"></fin-announcement-card>

        <ng-content select="[contentLeft]"></ng-content>
      </div>
      <div class="col-1-12 md-col-4-12">
        <ng-content></ng-content>
      </div>
    </div>
    <div class="ms-large-t">
      <ng-content select="[benefitBanner]"></ng-content>
    </div>
  </div>
</ng-container>
